/*-------------------------------------------
  Animation Effects
-------------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

MarquisFX = (function($) {
	var $animateElements;

	var fromEffects = {
		"opacity" : {opacity: "0"},
		"ttb" : {y: "-100%"},
		"btt" : {y: "200%"},
		"ltr" : {x: "-100%"},
		"rtl" : {x: "200%"}
	};

function init() {
	$animateElements = $('.marquis_fx .marquis_fx_callout');

	// Loops through each callout and find any element with the marquis_fx_element class.
	// It then looks at a data attribute for what effect to use.
	$($animateElements).each(function(index){

		$(this).find('.marquis_fx_element').each(function(i){
			var element = $(this);
			var effects = {};
			var data = $(this).data('marquis-fx').split(',');
			$(data).each(function(){
				effects = Object.assign(effects,fromEffects[this]);
			});
			var scrollTrigger = {
				scrollTrigger: {
					trigger: element,
					duration: 1,
					start: 'top bottom-=30%'
				}
			}
			var gsapParameters = Object.assign(effects,scrollTrigger);
			gsap.from(element, gsapParameters);
		});

	});
	}
	//Make sure the document has loaded before trying to find elements.
	$(document).ready(init);
})(jQuery);
